/*==========================================================
LAZY LOAD YOUTUBE SCRIPT
==========================================================*/
$(function () {
    lazyload();
    var div, n,
        v = document.getElementsByClassName("youtube-player");
    for (n = 0; n < v.length; n++) {
        div = document.createElement("div");
        div.setAttribute("data-id", v[n].dataset.id);
        div.setAttribute("tabindex", '0');
        div.setAttribute("role", 'button');
        div.setAttribute("class", 'youtube-player-thumb');
        div.innerHTML = youTubeLazyThumb(v[n].dataset.id);
        div.onclick = youTubeLazyIframe;
        div.onkeyup = youTubeLazyIframe;
        v[n].appendChild(div);
        if(v.length - 1 === n) {
            if ($('.youtube-player .youtube-player-thumb').length) {
                $('.youtube-player .youtube-player-thumb img').Lazy({
                    afterLoad: function(element) {
                        element.addClass('loaded-image');
                    }
                });
            }
        }
    }
});

function youTubeLazyThumb(id) {
    var thumb = '<img data-src="https://i.ytimg.com/vi/ID/hqdefault.jpg" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="">',
        play = '<div class="play"></div>';
    return thumb.replace("ID", id) + play;
}

function youTubeLazyIframe(event) {
    var code = event.keyCode || event.which;
    if (code == 1 || code == 13) { //Mouse click or enter keycode
        var iframe = document.createElement("iframe");
        var embed = "https://www.youtube.com/embed/ID?autoplay=1";
        iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        this.parentNode.replaceChild(iframe, this);
    }
}